import React from 'react';
import Html5QrcodePlugin from './html5BarcodeReader';

const BarcodeScanner = ({ onSuccess }) => {
  return (
    <div className="barcode-scanner m-b-3 ">
      <Html5QrcodePlugin
        fps={20}
        qrbox={{ width: 250, height: 150 }}
        disableFlip={false}
        qrCodeSuccessCallback={onSuccess}
        aspectRatio={1}
      />
    </div>
  );
};

export default BarcodeScanner;
